// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"be11cb8e","26":"9f809475","58":"87614cca","96":"89fff2e2","104":"2eccbce6","181":"1009ad97","267":"c1fd497c","479":"efb82ed1","490":"2df19715","522":"afba6752","693":"44cf193d","764":"03ba8922","836":"7864fd30","854":"102f3922","910":"27eb719d"}[chunkId] + ".chunk.js";
};